import React, { useState } from 'react'
import './OwnerAplications.css'
import { Badge, Collapse } from 'reactstrap'
import DetailsArrow from '../../utils/DetailsArrow'
// import UploadFileItem from './ApplicationsForm/UploadFileItem';
// import WarningModal from './ApplicationsForm/WarningModal';

const OwnerAplications = ({
  basvuruTarihi,
  adi,
  durum,
  renk,
  itemId,
  durumId,
  aciklama,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  // const [file, setFile] = useState([]);
  // const [filePreview, setFilePreview] = useState([]);
  // const [validExtBoll, setValidExtBool] = useState(null);
  // const [isModal, setIsModal] = useState({ type: '', active: false });

  // const hiddenFileInput = useRef(null);

  // const validExt = '.png, .pdf, .jpeg, .jpg';

  const toggleApp = (e) => {
    setIsOpen(!isOpen)
  }

  // const fileExtValidate = (fileUploaded) => {
  //   const filePath = fileUploaded?.name;
  //   const getFileExt = filePath
  //     .substring(filePath.lastIndexOf('.') + 1)
  //     .toLowerCase();
  //   const pos = validExt.indexOf(getFileExt);
  //   if (pos < 0) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  // const handleClick = (event) => {
  //   event.stopPropagation();
  //   hiddenFileInput.current.click();
  // };

  // const handleChange = (event) => {
  //   const fileUploaded = event.target.files[0];
  //   if (fileUploaded && fileExtValidate(fileUploaded)) {
  //     setValidExtBool(fileExtValidate(fileUploaded));
  //     setFile([...file, fileUploaded]);
  //     setFilePreview([
  //       ...filePreview,
  //       URL.createObjectURL(event.target.files[0]),
  //     ]);
  //     setIsModal({ type: '', active: false });
  //   } else {
  //     setValidExtBool(fileExtValidate(fileUploaded));
  //     setIsModal({ type: 'file', active: true });
  //     hiddenFileInput.current.value = null;
  //     setTimeout(() => {
  //       setIsModal({ type: '', active: false });
  //     }, 2300);
  //   }
  // };

  // const onFinish = () => {
  //   if (!file.length) {
  //     setIsModal((prevState) => ({ ...prevState, type: '', active: true }));
  //     setTimeout(() => {
  //       setIsModal((prevState) => ({ ...prevState, type: '', active: false }));
  //     }, 2300);
  //   }
  // };

  return (
    <>
      <div
        onClick={toggleApp}
        className='applications'
        style={{
          transition: 'border-color 0.8s ease',
          boxShadow: 'none',
          borderColor: '#efefe7',
        }}
      >
        <div className='applications-text'>
          <div>
            <p style={{ margin: 0, fontWeight: 'normal' }}>{adi}</p>
          </div>
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h6
              style={{
                marginRight: '0.5rem',
                marginTop: '0.5rem',
                fontSize: '10px',
                color: 'grey',
              }}
            >
              {isOpen ? 'Gizle' : 'Detay'}
            </h6>
            <DetailsArrow visible={isOpen} />
          </span>
        </div>
        <Collapse isOpen={isOpen}>
          <hr style={{ margin: '0.5rem 0' }} />

          <div className='content'>
            <span style={{ fontSize: '0.9rem' }}>Başvuru Numarası: </span>
            <span style={{ fontWeight: 400 }}>{`#${itemId}`}</span>
          </div>

          <div className='content'>
            <span style={{ fontSize: '0.9rem' }}>Başvuru Tarihi: </span>
            <span style={{ fontWeight: 400 }}>{basvuruTarihi}</span>
          </div>

          <div className='content'>
            <span style={{ fontSize: '0.9rem' }}>Başvuru Durumu: </span>
            {/* {!durum ? (
              <p style={{ fontWeight: 400 }}>{'Dekont bekleniyor.'}</p>
            ) : ( */}
            <Badge
              color={renk}
              pill
              style={{ textAlign: 'center', backgroundColor: 'red' }}
            >
              {durum}
            </Badge>
            {/* )} */}
          </div>
          {durumId === 4 && (
            <div className='content2'>
              {aciklama !== null && (
                <>
                  <span style={{ fontSize: '0.9rem' }}>Açıklama: </span>
                  <span style={{ fontWeight: 400 }}>{aciklama}</span>
                </>
              )}
            </div>
          )}

          {/* {durum === 'Dekont Bekleniyor' && (
            <>
              <div className='content'>
                <p style={{ fontSize: '0.9rem' }}>Dekont Yükle </p>
              </div>
              <UploadFileItem
                style={{ marginLeft: 15 }}
                files={file}
                filesPreview={filePreview}
                hiddenFileInput={hiddenFileInput}
                handleClick={handleClick}
                handleChange={handleChange}
                index={0}
              />
            </>
          )} */}
        </Collapse>
      </div>
      {/* <WarningModal isModal={isModal} onFinish={onFinish} files={file} /> */}
    </>
  )
}

export default OwnerAplications
